<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box-ins">
             <mobileMenu />
            <!--菜单-->
            <!-- <div class="ph-logo-a4 mt10 pl10">
                <a href="#" class="dbi fl he40">
                    <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a>
                <a href="#" class="dbi fr he20 white pr10 mt14 mr12">
                    <span class="f14 txtsh">MENU</span>
                    <i class="fa fa-bars f18 txtsh"></i></a>
            </div> -->
            <!--菜单end-->
            <!-- <div class="ph-phone-mu" style="">
                <ul class="ph-ph-um-ul">
                    <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a></li>
                    <li class="ph-ph-mu-li mt10"><a href="chanping-1.html" class="db white f15 lp2 pl10 txtsh">产品</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html" class="db white txtsh f15 lp2 pl10">解决方案</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="severHtml.html" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html" class="db white txtsh f15 lp2 pl10">关于我们</a>
                    </li>
                </ul>
            </div> -->
            <!--背景图-->
            <!-- <div class="ph-top-backgr">
                <div class="ph-top-box-ins-img"
                    style="background:url(../../assets/mobile/images/bana-13.jpg) center center no-repeat;background-size:cover;">
                </div>
                <div class="ph-top-box-ins-imga1"
                    style="background:url(../../assets/mobile/images/z10-ytj.png) center center no-repeat;background-size:300%,100%,cover;">
                </div>
            </div> -->
            <div class="ph-top-backgr ">
                <div class="ph-top-box-ins-img img1"></div>
                <div class="ph-top-box-ins-imga1 img2"></div>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="ph-main pt24">

            <!--解决方案-->
            <div class="w100 lh40 tc"> <span class="db f40 fb lp2 mt40">服务模式</span> <span
                    class="db f20  lp2 mt10 ph-col-gr">Service Model</span> </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc">行业痛点</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">云服务模式</span></strong><br>
                    依托高性能算力与先进AI技术，为中小企业及个人开发者提供开箱即用的视觉分析能力。通过与运营商深度合作，我们打造低门槛、高弹性的云化解决方案，支持图像识别、目标检测、生成式AI等多样化场景，用户无需复杂部署即可通过API快速调用。该服务采用按需付费模式，兼顾成本与效率，助力企业轻松实现智能化升级，让视觉AI能力触手可及。
                </p>
                <p class="tl mb40"><strong class="mb10 dbi"><span
                            style="color:rgb(255,0,0);">能力矩阵服务模式</span></strong><br>
                    面对政府、大型企业客户，采用集群部署的方式提供视觉大模型智能底座，为其各项业务场景提供视觉分析能力支持。</p>
                <p class="tl mb40"><strong class="mb10 dbi"><span
                            style="color:rgb(255,0,0);">一体机服务模式</span></strong><br>
                    在需要灵活部署或小规模视频接入的场景下，公司提供视觉大模型一体机。它是集成了前沿人工智能视觉大模型平台与高性能计算硬件的一站式智能设备，为用户提供开箱即用的视觉分析服务，无需复杂部署，助力各行业智能化升级与跨越式发展。
                </p>
            </div>
            <!--解决方案end-->
            <div class="w100 tc mt60"> <span class="db f40 fb lp2 mt40">生态合作</span><span
                    class="db f20  lp2 mt10 ph-col-gr">Ecological cooperation</span> </div>
            <!--产品-->
            <div class="ph-sthz clearfloat ov mt70">
                
                <div class="ph-jcrj jz mt100 ov">
                    <div class="ph-jcrj-a jz mt44"><img src="../../assets/mobile/images/y-b-6.jpg" width="100%"
                            alt="" /></div>
                </div>
            </div>
    

            <!--产品end-->
        </div>
        <!--内容大框end-->

        <!--底宣-->

        <!--底宣end-->
        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c"> <span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
import mobileMenu from './mobile-menu.vue';
</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-13.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/z10-ytj.png) center center no-repeat;
    background-size:300%,100%,cover;
}
</style>